import React from 'react'
import { clsx } from '../helpers'
import styles from './IconButton.module.css'

export const IconButton = props => {
  const { className, icon, color = 'default', ...ButtonProps } = props

  return (
    <div className={clsx(styles.root, className)} {...ButtonProps}>
      <svg className={clsx(styles.icon, styles[`color-${color}`])}>
        <use href={`#${icon}`}/>
      </svg>
    </div>
  )
}